import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfVictoria = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Victoria (UVic)"
      universityShortName="UVic"
      slug="university-of-victoria"
      seoTitle="UVic Study Rooms | Victoria Campus Library Study Guide"
      seoDescription="Complete guide to study rooms at University of Victoria. Find McPherson Library, Tek Booths, and walk-stations. Plus free 24/7 online alternative."
      seoKeywords="uvic study rooms, university of victoria library, mcpherson library, tek booths, victoria university study spaces"
      canonicalUrl="/study-room/university-of-victoria/"
      heroDescription="A comprehensive guide to study rooms at UVic, including versatile spaces like Tek Booths and walk-station desks."
      libraryWebsiteUrl="https://www.uvic.ca/library/"
      libraryWebsiteName="UVic Library"
      studySpaces={[
        {
          name: "Group Study Rooms",
          features: "Bookable rooms for group collaboration and projects.",
          feedback: "One booking per day for up to two hours; 15-minute no-show rule."
        },
        {
          name: "Tek Booths",
          features: "One- or two-person booths for online meetings and calls.",
          feedback: "Valued for Zoom calls but in short supply; no food or drink allowed."
        },
        {
          name: "Walk-Station Desks",
          features: "Walking desks for active studying.",
          feedback: "Popular for active learners; may be noisy for neighbors."
        },
        {
          name: "Mearns-McPherson Library - Quiet Areas",
          features: "Lower level, third floor, and third-floor mezzanine designated as quiet zones.",
          feedback: "Third-floor mezzanine often quieter than other spaces."
        },
        {
          name: "Priestly Library - Second Floor",
          features: "Quiet study area in the Law building.",
          feedback: "Good alternative for quiet focused work."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Book a <strong>Tek Booth</strong> if you need privacy for a call; avoid bringing food or drink inside. For active learners, try the <strong>walk-station near the library's main floor</strong>.
          </p>
          <p className="mb-4">
            If you want a quiet corner, head to the <strong>third-floor mezzanine or Priestly's second floor</strong>. Bookings can be made up to a week in advance.
          </p>
          <p>
            Students value the Tek Booths for Zoom calls but note that they're in short supply. Walk-stations are popular but may be noisy for neighbors.
          </p>
        </>
      }
      summaryTips={[
        "Book Tek Booths for calls: Perfect for Zoom meetings but limited availability.",
        "Try walk-stations for active study: Walk while you work (be mindful of noise).",
        "Head to third-floor mezzanine: Often quieter than other library areas.",
        "One booking per day: Plan ahead with the daily limit.",
        "Use CSW for unlimited calls: No booth shortages in virtual study rooms."
      ]}
    />
  );
};

export default UniversityOfVictoria;
